// extracted by mini-css-extract-plugin
export default {"svg-container":"Tcfbcz","svgContainer":"Tcfbcz"};